export default __webpack_public_path__ + "static/media/loader.3c02dc5b.gif";